/** The format of the Group ID MUST be a valid UTF8 string with the exception of the reserved characters of + (plus), / (forward slash), and # (number sign) */
export const applySparkplugRequirements = (str: string) => str.replaceAll(/[/#+\n]/gmu, '-');
